import {
  Action,
  moduleAction,
  handleModuleAction,
  oldModuleAction,
} from './callbacks/moduleAction'

import {
  cdcNavigate,
  handleCdcNavigate,
  handleNavigateToMBO,
  handleNavigateToMboHome,
  handleNavigateToMboModuleCatalog,
  handleNavigateToMboThemeCatalog,
  handleNavigateToModuleManagerUpdatesTab,
  handleNavigateToPage,
  handleReloadPage,
  navigateToMBO,
  navigateToMboHome,
  navigateToMboModuleCatalog,
  navigateToMboThemeCatalog,
  navigateToModuleManagerUpdatesTab,
  navigateToPage,
  reloadPage,
  urlSearchParams,
  useUrlSearchParams,
} from './callbacks/url'

import { scrollTo, handleScrollTo } from './callbacks/scrollTo'

import {
  growlNotification,
  handleGrowlNotification,
} from './callbacks/notification'

import { refreshToken, handleRefreshToken } from './callbacks/refreshToken'
import { handleResetMboModule } from './callbacks/resetMboModule'

import {
  handleAddonsPassword,
  handleAddonsUsername,
  useAddonsCredential,
  isConnectedToAddonsPS17,
  getAddonsPurchasedModules,
} from './useAddonsCredential'

import {
  handleAnalytics,
  handleAnalyticsLoaded,
  analytics,
  analyticsLoaded,
} from './analytics'

export const commonComponentsProps = {
  context: {
    type: 'object',
    required: true,
  },
  handleAddonsPassword,
  handleAddonsUsername,
  handleAnalytics,
  handleAnalyticsLoaded,
  handleGrowlNotification,
  handleModuleAction,
  handleNavigateToMBO,
  handleNavigateToModuleManagerUpdatesTab,
  handleNavigateToPage,
  handleNavigateToMboHome,
  handleNavigateToMboModuleCatalog,
  handleNavigateToMboThemeCatalog,
  handleRefreshToken,
  handleReloadPage,
  handleResetMboModule,
  handleScrollTo,
  useUrlSearchParams,
  handleCdcNavigate,
}

export const commonRenderProps = (props: any) => ({
  ...props,

  ...useAddonsCredential(),

  ...isConnectedToAddonsPS17(),

  handleAnalytics: (launchIdentity) => analytics(launchIdentity),

  handleAnalyticsLoaded: () => analyticsLoaded(),

  handleGrowlNotification: (type: string, message: string, title?: string) =>
    growlNotification(type, message, title),

  handleModuleAction: (
    action: Action,
    moduleName: string,
    moduleId: string,
    sourceUrl: string,
  ) =>
    props.context?.actions_url
      ? moduleAction(
          action,
          moduleName,
          props.context.actions_url,
          moduleId,
          sourceUrl,
        )
      : oldModuleAction(
          action,
          moduleName,
          parseInt(moduleId),
          props.context.admin_token,
          props.context.refresh_url,
        ),
        
  handleOldModuleAction: (
    action: Action,
    moduleName: string,
    moduleId: number,
  ) =>
    oldModuleAction(
      action,
      moduleName,
      moduleId,
      props.context.admin_token,
      props.context.refresh_url,
    ),

  handleNavigateToMBO: (path: string) => navigateToMBO(props?.context, path),

  handleNavigateToModuleManagerUpdatesTab: () =>
    navigateToModuleManagerUpdatesTab(props?.context),

  handleNavigateToPage: (url: string, newTab: boolean) =>
    navigateToPage(props?.context, url, newTab),

  handleNavigateToMboHome: (
    params?: Record<string, string>,
    newTab?: boolean,
    target?: string,
  ) => navigateToMboHome(props?.context, params, newTab || false, target),

  handleNavigateToMboModuleCatalog: (
    params?: Record<string, string>,
    scope?: string,
    newTab?: boolean,
  ) => navigateToMboModuleCatalog(props?.context, params, scope, newTab),

  handleNavigateToMboThemeCatalog: () =>
    navigateToMboThemeCatalog(props?.context),

  handleRefreshToken: (url: string) => refreshToken(url),

  handleReloadPage: () => reloadPage(),

  handleResetMboModule: () =>
    oldModuleAction(
      'reset',
      'ps_mbo',
      39574,
      props.context.admin_token,
      props.context.refresh_url,
      true,
    ),

  handleScrollTo: (xCoord: number, yCoord: number, source?: Element | Window) =>
    scrollTo(xCoord, yCoord, source),

  useUrlSearchParams: () => urlSearchParams(),

  handleGetAddonsPurchasedModules: () =>
    getAddonsPurchasedModules(props.context.admin_token),

  handleCdcNavigate: (cdc_path: string) => cdcNavigate(cdc_path),

  handleAssociateAccountCtaClick: () => {
    const cta = $('prestashop-accounts')[0]?.shadowRoot?.getElementById('set-point-of-contact-button')
      || $('prestashop-accounts')[0]?.shadowRoot?.getElementById('associate-shop-button')
    if (cta) {
      cta.click()
    } else {
      const accountsModule = props.context?.installed_modules?.find((m) => m.name === 'ps_accounts')
      if (accountsModule?.config_url) {
        window.location.href = accountsModule.config_url
      } else {
        throw new Error('ps_accounts module configuration not available')
      }
    }
  },
})
